<template>
    <div>
        <div class="mb-2">
            <v-card>
                <v-card-title>
                    Ventas Por Figura
                </v-card-title>
                <v-divider/>
                <v-card-text v-if="params.juego_sorteo_id" class="d-flex flex-wrap align-center justify-space-between">
                    <div>
                        <Totalizador
                            caption="SORTEO"
                            :loading="fetching"
                            :summary="report.summary?.sorteo"
                            />
                        <Totalizador
                            caption="DÍA"
                            :loading="fetching"
                            :summary="report.summary?.day"
                            />
                        <Totalizador
                            caption="SEMANA"
                            :loading="fetching"
                            :summary="report.summary?.week"
                            />
                    </div>
                    <div>
                        <h1>{{ ticketCount }} Tickets</h1>
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <v-card>
            <v-data-table
                :headers="headers"
                :items="list"
                :items-per-page="-1"
                :loading="fetching"
                disable-pagination
                disable-sort
                disable-filter
                hide-default-footer
                >
                <!-- eslint-disable-next-line -->
                <template v-slot:item.comercio="{ item }">
                    <div v-if="context == 'comercio'">
                        <small class="d-flex">{{ item.parentComercio }}</small>
                        <v-btn text small @click="open({
                            'comercio': 'reporte.figura',
                            'sistema': 'operadora.sistema.reporte.figura',
                        }[context], {
                            comercio: {
                                type: item.comercio_type,
                                id: item.comercio_id,
                            }
                        })">
                            <v-icon class="mr-2" small>mdi mdi-eye-outline</v-icon>
                            {{ item.comercio }} 
                        </v-btn>
                    </div>
                    <div v-if="context == 'sistema'">
                        {{ item.comercio }} 
                    </div>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.tickets="{ item }">
                    <v-btn small class="mr-2" text @click="open({
                        'comercio': 'tickets',
                        'sistema': 'operadora.sistema.tickets',
                    }[context], {
                        numero: item.figura.value
                    })">
                        <v-icon class="mr-2" small>mdi mdi-receipt-text</v-icon>
                        {{ item.count }}
                    </v-btn>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.venta="{ item }">
                    {{ item.venta | currency(item.divisa_code) }}
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.comision="{ item }">
                    {{ item.comision | currency(item.divisa_code) }}
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.projected="{ item }">
                    <v-chip small label :color="item.premioColor" class="font-weight-bold mr-2">
                        {{ item.projected | currency(item.divisa_code) }} {{' / '}} {{ item.percent_premio | percent }}
                    </v-chip>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.total_projected="{ item }">
                    <v-chip small label :color="item.sorteoColor" class="font-weight-bold mr-2">
                        Sorteo <v-divider vertical class="mx-3"/> {{ item.related_comercio.sorteo.total | currency(item.divisa_code) }}
                    </v-chip>
                    <v-chip small label :color="item.dayColor" class="font-weight-bold mr-2">
                        Día <v-divider vertical class="mx-3"/> {{ item.related_comercio.day.total | currency(item.divisa_code) }}
                    </v-chip>
                    <v-chip small label :color="item.weekColor" class="font-weight-bold">
                        Semana <v-divider vertical class="mx-3"/> {{ item.related_comercio.week.total | currency(item.divisa_code) }}
                    </v-chip>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import ReportePorFiguraService from '@/services/reporte/ventas/ReportePorFiguraService';

import Totalizador from '@components/entities/reporte/venta/figura/totalizador';

const reportDefault = {
    summary: {},
    detail: [],
};

export default {
    components: {
        Totalizador
    },
    props: {
        params: {
            defaults: function() {
                return {

                };
            },
        },
        context: {
            default: 'comercio',
        },
        loading: {
            type: Boolean,
            default: true,
        }
    },
    data: function() { 
        return {
            report: { ... reportDefault },
            fetching: true,
            ticketCount: 0,
        }
    },
    computed: {
        headers: function () {
            return [
                ... this.context == 'sistema' ? [{ text: 'Sistema', align: 'start', value: 'comercio' }] : [{ text: 'Comercio', align: 'start', value: 'comercio' }],
                { text: 'Tickets',align: 'start', value: 'tickets' },
                { text: 'Venta', value: 'venta' },
                { text: 'Comisión', value: 'comision' },
                { text: 'Premio', value: 'projected' },
                { text: 'Total', value: 'total_projected' },
            ];
        },
        divisa: function () {
            return this.$store.getters['persist/divisa/selected'];
        },
        list: function () {
            return this.report.detail.map(report => {
                return {
                    ...report,
                    premioColor: report.percent_premio <= 1 ? 'primary': 'error',
                    sorteoColor: report.related_comercio.sorteo.total == 0 
                                    ? 'secondary' 
                                    : report.related_comercio.sorteo.total > 0 
                                        ? 'primary'
                                        : 'error',
                    dayColor: report.related_comercio.day.total == 0 
                                    ? 'secondary' 
                                    : report.related_comercio.day.total > 0 
                                        ? 'primary'
                                        : 'error',
                    weekColor: report.related_comercio.week.total == 0 
                                    ? 'secondary' 
                                    : report.related_comercio.week.total > 0 
                                        ? 'primary'
                                        : 'error',
                    parentComercio: ['master', 'comercializadora', 'grupo', 'taquilla'].reduce((text, comercio, index) => {
                        if (!report[comercio +'_name']) return text;
                        return `${text}${index !== 0 ? ' - ' : ''}${report[comercio +'_name']}`; 
                    }, '')
                }
            })
        },
    },
    methods: {
        fetchReport: function () {
            this.report = { ... reportDefault };
            this.fetching = true;
            this.ticketCount = 0;

            const params = { ...this.params, divisa_id: this.divisa.id };

            if (this.context == 'sistema') {
                params['group_by'] = 'sistema';
                params['comercio_type'] = 'sistema';
            }

            ReportePorFiguraService.getDetallado(params)
                .then(({ report }) => {
                    this.report = report;
                    this.ticketCount = report.detail.reduce((sum, item) => {
                        return sum + item.count;
                    }, 0);
                }).finally(() => {
                    this.fetching = false;
                });
        },
        open: function (route, filters, context = 'tab') {
            const comercio = filters.comercio;
            delete filters.comercio;
            
            const query = {
                ... this.params,
                ... filters,
            };
            
            if (comercio) query[`${comercio.type}_id`] = comercio.id;
            
            const $route = this.$router.resolve({
                name: route,
                query: query,
            });

            if (context == 'tab') return window.open(new URL($route.href, window.location.origin), '_blank').focus();
            if (context == 'window') return window.open(new URL($route.href, window.location.origin), '_blank', 'titlebar=no, status=no, menubar=no, height=600 width=1000');
        }
    },
    watch: { 
        'params': function () {
            this.fetchReport();
        },
        'divisa': function () {
            this.fetchReport();
        },
        'fetching': function (fetching) {
            this.$emit('update:loading', fetching);
        }
    },
    mounted: function () {
        this.$emit('update:loading', this.fetching);
        this.fetchReport();
    }
}
</script>
<style>

</style>